import { State } from "@ngxs/store";
import { Injectable } from "@angular/core";

// in terms of other state management libs, this is our root reducer
@State<string[]>({
    name: 'animals',
    defaults: []
})
@Injectable()
export class AppState {

}
